import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import theme from 'source/theme';

const columns = [
  { title: 'Codigo Fornecimento', field: 'shipment_code' },
  { title: 'Designação comercial', field: 'trade_name' },
  {
    title: 'Ativo',
    field: 'active',
    render: value =>
      <span style={{ fontWeight: value ? 'bold' : null }}>
        {value ? 'Sim' : 'Não'}
      </span>
  }
];

export default props => {
  const { rowData, data, title } = props;

  const rows = rowData.map(fsup => ({
    ...data[fsup.supplier_id],
    trade_name: fsup.trade_name,
    shipment_code: fsup.code
  }));

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} rows={rows} title={title}/>
    </div>
  );
};
